import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';

import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import { ModalType } from '~/components/Modal/interface';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';
import { useModal } from '~/hooks/useModal';
import type { CartItem } from '~/stores/CartStore';

import styles from './CheckoutProductCard.module.scss';

type Props = {
  offer: CartItem;
  disabled?: boolean;
};

const CheckoutProductCard = ({ offer, disabled }: Props) => {
  const { openModal } = useModal();
  const { handleClickProduct } = useCategoryAnalytics();

  const handleOpenProduct = () => {
    openModal(ModalType.ProductDetails, undefined, {
      productId: offer.productId.toString(),
      sku: offer.sku as string,
    });
    handleClickProduct(offer);
  };

  return (
    <button
      onClick={handleOpenProduct}
      disabled={disabled}
      className={classes([styles.checkoutProductCard])}
    >
      <div className={styles.image}>
        <CloudflareResponseImage
          src={offer.previewImageThumb || ''}
          srcParams={{ width: 56, height: 56 }}
          srcSetParams={defaultSrcSetParams}
          alt={offer.name}
          loading="lazy"
        />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{offer.name}</div>
        <div className={styles.count}>{offer.count}x</div>
      </div>
    </button>
  );
};

export default observer(CheckoutProductCard);
